import React, { useEffect } from "react";

import Navbar from "../Navbar";

import Fade from "react-reveal/Fade";

import "./style.css";

function Contact() {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = "Surya Mahla - Let's Talk";
  }, []);

  return (
    <>
      <Navbar />
      <Fade duration={500}>
        <div className="contact">
          {/* <iframe
            src="https://calendly.com/suryamahla"
            className="contact__calendly__embed"
            frameborder="0"
          ></iframe> */}

          <iframe
            title="setmore meeting schedule"
            src="https://my.setmore.com/bookingpage/c11f2dfa-36e2-47b3-9add-23d4950607fb"
            className="contact__setmore__embed"
            frameborder="0"
          ></iframe>
        </div>
      </Fade>
    </>
  );
}

export default Contact;
